import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig, nativeReady, RUNS_NATIVE } from './app/app.config';
import { App } from './app/app';

// In the apps, Angular starts once their own storage is open (app.config.ts); the web build folds
// this back to the plain bootstrap.
(RUNS_NATIVE
  ? nativeReady.then(() => bootstrapApplication(App, appConfig))
  : bootstrapApplication(App, appConfig)
).catch((err) => console.error(err));
